import { useParams } from 'react-router';
import { StaffTeamGrid } from '../components/StaffTeamGrid';
import { useStaffCustomerTeams } from '../hooks/useStaffCustomer';

export function CustomerTeamsPage() {
  const { accountId } = useParams();
  const { data, loading, error } = useStaffCustomerTeams(accountId);
  const teams = data?.staffCustomerTeams ?? [];

  if (error) {
    return (
      <div className="rounded-md border border-destructive/30 bg-destructive/5 p-4 text-sm text-destructive">
        {error.message}
      </div>
    );
  }

  return (
    <div data-testid="customer-teams-page">
      <StaffTeamGrid teams={teams} loading={loading} />
    </div>
  );
}
